import { Pipe, PipeTransform } from '@angular/core';

/**
  * InitialsPipe
  *
  * A pipe to return initials of a user.
  */
@Pipe({ name: 'initials' })
export class InitialsPipe implements PipeTransform {
  /**
  * Accepts a user Object and returns the user initials.
  *
  * @param {any} user A user Object.
  * @return {string} Returns initial.
  */
  transform(user: any): string {
    return user.first_name || user?.last_name ? `${user?.first_name?.charAt(0)}${user?.last_name?.charAt(0)}`.toUpperCase() : user?.email?.charAt(0).toUpperCase() || '';
  }
}
